var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAbnormalCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "AbnormalCircle_svg__a",
  width: 20,
  height: 20,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h20v20H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#AbnormalCircle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "red",
  d: "m10 11.167 2.417 2.417a.8.8 0 0 0 .583.229.8.8 0 0 0 .584-.23.8.8 0 0 0 .229-.583.8.8 0 0 0-.23-.583L11.168 10l2.417-2.416A.8.8 0 0 0 13.813 7a.8.8 0 0 0-.23-.583.8.8 0 0 0-.583-.23.8.8 0 0 0-.583.23L10 8.834 7.584 6.417A.8.8 0 0 0 7 6.187a.8.8 0 0 0-.583.23.8.8 0 0 0-.23.583q0 .354.23.584L8.834 10l-2.417 2.417a.8.8 0 0 0-.23.583q0 .354.23.584a.8.8 0 0 0 .583.229.8.8 0 0 0 .584-.23zm0 7.167a8.1 8.1 0 0 1-3.25-.657 8.4 8.4 0 0 1-2.646-1.78 8.4 8.4 0 0 1-1.78-2.647A8.1 8.1 0 0 1 1.666 10q0-1.729.656-3.25a8.4 8.4 0 0 1 1.781-2.646 8.4 8.4 0 0 1 2.646-1.78A8.1 8.1 0 0 1 10 1.666q1.73 0 3.25.656a8.4 8.4 0 0 1 2.646 1.781 8.4 8.4 0 0 1 1.781 2.646 8.1 8.1 0 0 1 .657 3.25 8.1 8.1 0 0 1-.657 3.25 8.4 8.4 0 0 1-1.78 2.646 8.4 8.4 0 0 1-2.647 1.781 8.1 8.1 0 0 1-3.25.657m0-1.667q2.792 0 4.73-1.938 1.937-1.937 1.937-4.729 0-2.79-1.938-4.729Q12.793 3.334 10 3.334q-2.79 0-4.729 1.937-1.937 1.938-1.937 4.73 0 2.79 1.937 4.729 1.938 1.937 4.73 1.937"
}))));
export default SvgAbnormalCircle;